import { render, staticRenderFns } from "./ProfileMedicalHistoryList.vue?vue&type=template&id=6b6ee502&"
import script from "./ProfileMedicalHistoryList.vue?vue&type=script&lang=js&"
export * from "./ProfileMedicalHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports